import { render, staticRenderFns } from "./HelloI18n.vue?vue&type=template&id=2c7676ca&"
import script from "./HelloI18n.vue?vue&type=script&lang=js&"
export * from "./HelloI18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports